import { useMemo } from 'react';

type SearchableOption = {
  label: string;
  secondaryText?: string;
};

/**
 * Custom hook to filter options based on search query
 * Searches across all visible fields (label and secondaryText) for comprehensive matching
 */
export const useSearchFilter = <T extends SearchableOption>(
  options: T[],
  searchQuery: string,
  searchable: boolean
): T[] => {
  return useMemo(() => {
    if (!searchable || !searchQuery.trim()) {
      return options;
    }

    const query = searchQuery.toLowerCase();
    return options.filter((option) => {
      // Search across all visible fields
      const searchableFields = [option.label, option.secondaryText]
        .filter(Boolean)
        .map((field) => String(field).toLowerCase());

      // Check if query matches any field
      return searchableFields.some((field) => field.includes(query));
    });
  }, [options, searchQuery, searchable]);
};
